import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;

  & div.ant-collapse-header[role='tab'] {
    align-items: center;
  }
`;
